module.exports = __webpack_public_path__ + "media/images/city/074-angkor-wat-8056d3b679d350daa758631a53251de3.svg";